import { datetimeToSec, toPercentFixed } from '@/common/js/filters'

export const tableCols = [
  {
    title: 'ID',
    key: 'id',
    width: 62,
    fixed: true
  },
  {
    title: '素材名称',
    key: 'imageName',
    width: 160,
    fixed: true,
    overflow: true
  },
  {
    title: '上传时间',
    key: 'uploadTime',
    width: 134,
    sortable: 'custom',
    format: (row) => datetimeToSec(row.uploadTime)
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: 72,
    sortable: 'custom',
    format: (row) => toPercentFixed(row.clickRate)
  },
  {
    title: '实际消耗',
    key: 'amount',
    width: 82,
    sortable: 'custom'
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    width: 82,
    sortable: 'custom'
  },
  {
    title: '新创角付费成本',
    key: 'payCost',
    width: 122,
    sortable: 'custom'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: 72,
    sortable: 'custom',
    format: (row) => toPercentFixed(row.activeRate)
  },
  {
    title: '新创角付费率',
    key: 'payRoleUserRate',
    width: 120,
    sortable: 'custom',
    format: (row) => toPercentFixed(row.payRoleUserRate)
  },
  {
    title: '首日ROI',
    key: 'oneDayRoi',
    width: 82,
    sortable: 'custom',
    format: (row) => toPercentFixed(row.oneDayRoi)
  },
  {
    title: '3日ROI',
    key: 'threeDayRoi',
    width: 82,
    sortable: 'custom',
    format: (row) => toPercentFixed(row.threeDayRoi)
  },
  {
    title: '7日ROI',
    key: 'sevenDayRoi',
    width: 82,
    sortable: 'custom',
    format: (row) => toPercentFixed(row.sevenDayRoi)
  }
]

/**
 * @description: 素材选择框的素材类型
 */
export const MATERIAL_TYPE = {
  VIDEO: 'video', // 视频
  IMAGE: 'image', // 图片
  GROUP_IMAGE: 'group_image', // 组图
  POSTER: 'poster', // 封面
  LOGO: 'logo', // 封面
  STICKER: 'sticker', // 贴纸
  AUDIO: 'audio', // 音频
  FAV: 'fav', // 个人收藏
  IMAGE_AUDIO: 'image_audio', // 图文
  META: 'meta',
  SHOT: 'shot'
}

/**
 * @description: 素材选择框的素材类型ID，接口请求根据id区分
 * http://yapi.caohua.info/project/118/interface/api/1314
 * 1单图 2双图 3三图 4视频 6头条视频 7头条图片 8LOGO
 */
export const MATERIAL_TYPE_ID = {
  [MATERIAL_TYPE.VIDEO]: 4, // 视频
  [MATERIAL_TYPE.IMAGE]: 1, // 图片
  [MATERIAL_TYPE.GROUP_IMAGE]: 13, // 组图
  [MATERIAL_TYPE.POSTER]: 'poster', // 封面
  [MATERIAL_TYPE.LOGO]: 8, // logo
  [MATERIAL_TYPE.STICKER]: 9, // 贴纸
  [MATERIAL_TYPE.AUDIO]: 10, // audio
  [MATERIAL_TYPE.IMAGE_AUDIO]: 11, // 图文
  [MATERIAL_TYPE.FAV]: 12, // 个人收藏
  [MATERIAL_TYPE.META]: 14, // 元素材
  [MATERIAL_TYPE.SHOT]: 18 // 分镜切片

}

export const MATERIAL_TYPE_NAME = {
  [MATERIAL_TYPE.VIDEO]: '视频',
  [MATERIAL_TYPE.IMAGE]: '图片',
  [MATERIAL_TYPE.GROUP_IMAGE]: '组图',
  [MATERIAL_TYPE.POSTER]: '封面',
  [MATERIAL_TYPE.LOGO]: 'logo',
  [MATERIAL_TYPE.STICKER]: '贴纸',
  [MATERIAL_TYPE.AUDIO]: '音频',
  [MATERIAL_TYPE.FAV]: '个人收藏',
  [MATERIAL_TYPE.IMAGE_AUDIO]: '图文',
  [MATERIAL_TYPE.META]: '元素材',
  [MATERIAL_TYPE.SHOT]: '分镜切片'
}
